export default __webpack_public_path__ + "static/media/g1.b4da346c.jpg";